import{watchEffect as i}from"vue";import{isServer as a}from'../utils/ssr.js';function E(n,e,o,r){a||i(t=>{n=n!=null?n:window,n.addEventListener(e,o,r),t(()=>n.removeEventListener(e,o,r))})}export{E as useEventListener};
